import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { InlineLabelPlacement } from './types';

const inlineLabelBase = css`
  line-height: 1.35;
`;

const inlineLabelDisabled = css`
  opacity: 0.25;
`;

const inlineLabelPlacementLeft = css`
  margin-right: ${theme.spacing(2)};
`;

const inlineLabelPlacementRight = css`
  margin-left: ${theme.spacing(1)};
`;

export const getInlineLabelClassName = ({
  disabled,
  placement,
}: {
  disabled?: boolean;
  placement?: InlineLabelPlacement;
}) =>
  cx(
    inlineLabelBase,
    disabled && inlineLabelDisabled,
    placement === 'left' ? inlineLabelPlacementLeft : inlineLabelPlacementRight
  );
